export const formatTenantAppTime = (
    timestamp: number,
    timezone?: string,
    locale?: string
): string => {
    const date = new Date(timestamp);

    if (Number.isNaN(date.getTime())) return '';

    return new Intl.DateTimeFormat(locale, {
        timeZone: timezone,
        hour: '2-digit',
        minute: '2-digit'
    }).format(date);
};